import { createSlice } from "@reduxjs/toolkit";
import regularizationApi from "../../api/regularizationApi";

const initialState = {
  statuses: [],
  regularizationHistory:[],
  pendingRegularization: [],
  regularizationEmployeeId:'',
  isReviewRegularizationScreen : false,
  regularization: {
    cc: [],
    remarks: "",
    entries: [],
  },
};

const regularizationSlice = createSlice({
  name: "regularization",
  initialState,
  reducers: {
    setRegularization: (state, action) => {
      state.regularization = action.payload;
    },
    setRegularizationEmployeeId: (state, action) => {
      state.regularizationEmployeeId = action.payload;
    },
    setIsReviewRegularizationScreen : (state, action) => {
      state.isReviewRegularizationScreen = action.payload;
    },
    setPendingRegularization: (state, action) => {
      state.pendingRegularization = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      regularizationApi.endpoints.fetchRegularizationStatus.matchFulfilled,
      (state, action) => {
        state.statuses = action.payload.data;
      }
    );
    builder.addMatcher(
      regularizationApi.endpoints.getRegularizationHistory.matchFulfilled,
      (state, action) => {
        state.regularizationHistory = action.payload.data;
      }
    );
    builder.addMatcher(
      regularizationApi.endpoints.getPendingRegularization.matchFulfilled,
      (state, action) => {
        state.pendingRegularization = action.payload.data;
      }
    );
  },
});

export const {
  setRegularization,
  setRegularizationEmployeeId,
  setIsReviewRegularizationScreen,
  setPendingRegularization,
} = regularizationSlice.actions;

export default regularizationSlice.reducer;
